module.exports = __webpack_public_path__ + "static/media/AvisoBomberos.eac5a369.png";